export default {"src":"/_next/static/media/cloudLightning_24.d997d476.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};